module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/f3ee0081a94d508a5c5e08069c1b5de3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver2.svg
// module id = qfeG
// module chunks = 1